import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getShelfShoppingPackages, getAllSuites } from "../../../../helper/functions";
import { setRequests } from "../../../../store/commonSlice";

/**
 * Custom hook to fetch and manage shopping packages data
 * @param {Object} selectedFilters - Current filter state
 * @returns {boolean} Loading state
 */
export const useShoppingData = (selectedFilters) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const getPackages = async () => {
    try {
      setLoading(true);
      const shelfShoppingPackage = await getShelfShoppingPackages([]);
      
      // Extract unique suite IDs
      const usersMySuites = [];
      shelfShoppingPackage.forEach((pack) => {
        if (pack?.mySuiteId && !usersMySuites.includes(pack?.mySuiteId)) {
          usersMySuites.push(pack?.mySuiteId);
        }
      });
      console.log(usersMySuites, "usersMySuites");

      // Build filter conditions
      const extra = [];
      if (selectedFilters?.routePartnerId) {
        extra.push({
          key: "routePartnerId",
          operator: "==",
          value: selectedFilters?.routePartnerId,
        });
      }
      if (selectedFilters?.warehouseId) {
        extra.push({
          key: "routePartnerMainAddressId",
          operator: "==",
          value: selectedFilters?.warehouseId,
        });
      }

      // Fetch suites if we have suite IDs
      if (usersMySuites?.length > 0) {
        console.log(usersMySuites, "usersMySuitesusersMySuites");
        const allSuites = await getAllSuites([
          ...extra,
          {
            key: "__name__",
            operator: "in",
            value: usersMySuites,
          },
        ]);
        console.log(allSuites, "allSites in shopping");
        dispatch(setRequests(allSuites));
      } else {
        dispatch(setRequests([]));
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching shopping packages:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    getPackages();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilters]);

  return loading;
};

